import React from 'react';

interface WeeklyHoursWarningProps {
  weeklyHours: number;
}

const WeeklyHoursWarning: React.FC<WeeklyHoursWarningProps> = ({ weeklyHours }) => {
  const limit = 52;
  const isAtRisk = weeklyHours >= 48; // 48시간 넘으면 경고
  const isViolation = weeklyHours > limit; // 52시간 초과 시 위반

  const percentage = Math.min(100, (weeklyHours / limit) * 100);
  const remaining = Math.max(0, limit - weeklyHours);

  // 그라데이션 색상 (상태별)
  const gradientClass = isViolation 
    ? 'bg-gradient-to-r from-red-500 via-pink-500 to-orange-500' // 위반: 빨강~핑크~오렌지
    : isAtRisk 
    ? 'bg-gradient-to-r from-yellow-500 via-amber-500 to-orange-500' // 경고: 노랑~호박~오렌지
    : 'bg-gradient-to-r from-blue-500 via-indigo-500 to-purple-500'; // 안전: 파랑~남색~보라

  return (
    <div className={`rounded-2xl p-4 shadow-lg ${gradientClass}`}>
      <div className="flex items-center justify-between mb-2">
        <div className="flex items-center gap-2">
          <span className="text-2xl">
            {isViolation ? '🚨' : isAtRisk ? '⏰' : '⏱️'}
          </span>
          <span className="text-white text-sm font-bold">이번 주 근무시간</span>
        </div>
        <div className="bg-white bg-opacity-30 backdrop-blur-sm text-white text-xs font-bold px-3 py-1 rounded-full">
          {isViolation ? '위반' : isAtRisk ? '경고' : '안전'}
        </div>
      </div>
      
      <div className="flex items-center justify-between">
        <div>
          <p className="text-4xl font-black text-white mb-1">
            {weeklyHours.toFixed(1)}시간
          </p>
          <p className="text-xs text-white text-opacity-80">
            {isViolation 
              ? '근로기준법 위반!' 
              : isAtRisk 
              ? `${remaining.toFixed(1)}시간만 더 가능` 
              : `${remaining.toFixed(1)}시간 더 근무 가능`}
          </p>
        </div>

        {/* 프로그레스 바 */}
        <div className="flex flex-col items-end gap-1">
          <div className="w-24 bg-white bg-opacity-30 rounded-full h-3">
            <div 
              className="bg-white h-3 rounded-full transition-all shadow-lg"
              style={{ width: `${percentage}%` }}
            ></div>
          </div>
          <span className="text-xs text-white text-opacity-70">최대 52시간</span>
        </div>
      </div>
    </div>
  );
};

export default WeeklyHoursWarning;
